/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OccupancyRatesPerDay } from '../../models/occupancy-rates-per-day';

export interface GetStationOccupancy$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStationOccupancy(http: HttpClient, rootUrl: string, params: GetStationOccupancy$Params, context?: HttpContext): Observable<StrictHttpResponse<OccupancyRatesPerDay>> {
  const rb = new RequestBuilder(rootUrl, getStationOccupancy.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OccupancyRatesPerDay>;
    })
  );
}

getStationOccupancy.PATH = '/stations/{uid}/occupancy';
